import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/atupertu',
            name: 'atupertu',
            meta: {
                showNavbar: false
            },
            component: () => import("./atupertu.vue")
        },
        {
            path: '/atupertu/category/:categoria',
            name: 'atupertuCategoria',
            meta: {
                showNavbar: false
            },
            component: () => import("./atupertuCategoria.vue")
        },
        {
            path: '/atupertu/category/:categoria/:consulente',
            name: 'atupertuCategoriaConsulenteDetail',
            meta: {
                showNavbar: false
            },
            component: () => import("./atupertuConsulenteDetail.vue")
        },
        {
            path: '/atupertu/prenotazione/:identifier',
            name: 'atupertuCategoriaDetailConfermata',
            meta: {
                showNavbar: false
            },
            component: () => import("./atupertuConfermata.vue")
        },
        {
            path: '/atupertu/prenotazione/:identifier/edit',
            name: 'atupertuCategoriaDetailConfermata edit',
            meta: {
                showNavbar: false
            },
            component: () => import("./components/EditBooking.vue")
        },
        {
            path: '/atupertu/purchase/:categoria',
            name: 'atupertuPurchase',
            component: () => import("./atupertuPurchase.vue")
        },
        {
            path: '/atupertu/purchase/:categoria/:consulente/:fromconsulentedetail',
            name: 'atupertuPurchase and consulente',
            component: () => import("./atupertuPurchase.vue")
        },
    ];
};